function SectionPagination() {
    const handlePageClick = (page) => {
        window.dispatchEvent(new CustomEvent("jobzilla:pagination", { detail: { page } }));
    };

    return (
        <>
            <div className="pagination-outer">
                <div className="pagination-style1">
                    <ul className="clearfix">
                        <li className="prev"><button type="button" onClick={() => handlePageClick("prev")}><span> <i className="fa fa-angle-left" /> </span></button></li>
                        <li><button type="button" onClick={() => handlePageClick(1)}>1</button></li>
                        <li className="active"><button type="button" onClick={() => handlePageClick(2)}>2</button></li>
                        <li><button type="button" onClick={() => handlePageClick(3)}>3</button></li>
                        <li><span className="pagination-ellipsis"><i className="fa fa-ellipsis-h" /></span></li>
                        <li><button type="button" onClick={() => handlePageClick(5)}>5</button></li>
                        <li className="next"><button type="button" onClick={() => handlePageClick("next")}><span> <i className="fa fa-angle-right" /> </span></button></li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default SectionPagination;